module.exports = "<button class=\"cy-welcome-cashier-button cgp-cashier cashier-btn cgp-themes-main-cta\">{logged_in_cashier_btn | translate}</button>";